import React from "react";
import "./Breadcrumb_comp.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const BreadcrumbComp = ({ data }) => {
  return (
    <div className="Breadcrumb_comp">
      <Breadcrumb>
        {data?.map((item, index) => (
          <Breadcrumb.Item
            key={index}
            href={item.link}
            active={index === data.length - 1} // Mark the last item as active
          >
            {item.name} {index !== data.length - 1 && <FontAwesomeIcon icon={faChevronRight} />}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default BreadcrumbComp;
